export default __webpack_public_path__ + "static/media/basicRectangle.9dc8a941.svg";